import {Component, Inject} from '@angular/core';
import {kanUsersService} from "../../../services/services/users";
import {User} from "../../../../classes/user";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material";
import {Service} from "../../../../classes/service";
import {kanServicesService} from "../../../services/services/services";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {ServiceLog} from "../../../../classes/serviceLog";
import {Dog} from "../../../../classes/dog";
import {getDateString} from "../../../../utils/dateFormat";

@Component({
    selector: 'kan-service-log-dialog',
    templateUrl: './component.html',
    styleUrls: ['./component.scss']
})
export class kanServiceLogDialog {
    public serviceType: string;
    public lastServiceTypeCall: string;
    public serviceTypes: string[] = ['USER', 'DOG'];
    public services: Service[];
    public service: Service;
    public dogs: Dog[];
    public dog: Dog;
    public user: User;
    public start: string = getDateString(new Date());
    public end: string;
    public notes: string;
    public isNew: boolean = true;
    public hasDog: boolean = false;
    public initiatives: string[] = ['USER', 'FAMILY', 'OTHER'];
    public initiative: string = 'USER';
    public serviceLog: ServiceLog = new ServiceLog();

    public serviceToForm: FormGroup;
    public serviceDataForm: FormGroup;

    constructor(private dialogRef: MatDialogRef<kanServiceLogDialog>,
                private formBuilder: FormBuilder,
                private servicesService: kanServicesService,
                private usersService: kanUsersService,
                @Inject(MAT_DIALOG_DATA) private data: any) {

        if (this.data && this.data.user) {
            this.user = this.data.user;
        }

        if (this.data && this.data.userId) {
            this.serviceLog.userId = this.data.userId;
        }

        if (this.data && this.data.dog) {
            this.dog = this.data.dog;
            this.serviceType = 'DOG';
            this.hasDog = true;
        }

        if (this.data && this.data.dogId) {
            this.serviceLog.dogId = this.data.dogId;
            this.serviceType = 'DOG';
            this.hasDog = true;
        }

        if (this.data && this.data.serviceLog) {
            this.serviceLog = JSON.parse(JSON.stringify(this.data.serviceLog));
            this.service = this.serviceLog.service;
            this.start = this.serviceLog.start ? getDateString(new Date(this.serviceLog.start)) : '';
            this.end = this.serviceLog.end ? getDateString(new Date(this.serviceLog.end)) : '';
            this.notes = this.serviceLog.notes || '';
            this.initiative = this.serviceLog.initiative || 'USER';
            this.isNew = false;
        }
    }

    ngOnInit(): void {
        if (this.serviceLog.userId) {
            this.usersService.getDogs(this.serviceLog.userId)
                .then((dogs) => {
                    this.dogs = dogs;
                })
                .catch((error) => {
                    console.log(error);
                });
        }

        this.serviceToForm = this.formBuilder.group({
            serviceType: new FormControl(this.serviceType, [Validators.required]),
            service: new FormControl(this.service, [Validators.required]),
            dog: new FormControl(this.dog)
        });

        this.serviceDataForm = this.formBuilder.group({
            start: new FormControl(this.start, [Validators.required]),
            end: new FormControl(this.end),
            initiative: new FormControl(this.initiative, [Validators.required]),
            notes: new FormControl(this.notes)
        });
    }

    ngDoCheck(changes) {
        if (this.serviceType && this.serviceType !== this.lastServiceTypeCall) {
            this.lastServiceTypeCall = this.serviceType;
            if (!this.hasDog) {
                this.service = null;
                this.dog = null;
            }
            this.servicesService.getServices({where: {type: this.serviceType}})
                .then((services) => {
                    this.services = services;
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    }

    public addService(event) {
        // this.serviceLog.userId = this.user.id;
        // this.serviceLog.dogId = this.dog ? this.dog.id : null;
        this.serviceLog.serviceId = this.service.id;
        this.serviceLog.start = new Date(this.start);
        this.serviceLog.end = this.end ? new Date(this.end) : null;
        this.serviceLog.notes = this.notes ? this.notes : null;
        this.serviceLog.initiative = this.initiative;

        this.servicesService.addServiceLog(this.serviceLog)
            .then((serviceLog) => {
                this.dialogRef.close('add');
            })
            .catch((error) => {
                console.log(error);
            });
    }

    public updateService(event) {
        this.serviceLog.start = new Date(this.start);
        this.serviceLog.end = this.end ? new Date(this.end) : null;
        this.serviceLog.notes = this.notes ? this.notes : null;
        this.serviceLog.initiative = this.initiative;

        this.servicesService.updateServiceLog(this.serviceLog)
            .then((serviceLog) => {
                this.dialogRef.close('update');
            })
            .catch((error) => {
                console.log(error);
            });
    }
}



// WEBPACK FOOTER //
// ./src/modules/admin/dialogs/service-log-dialog/component.ts